import React from "react";
import { Box, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import clsx from "clsx";
import "../../styles/analytics.css";

interface EditableCellProps {
  value: string;
  active?: boolean;
  onClick: (anchorEl: HTMLElement) => void;
}

const EditableCell: React.FC<EditableCellProps> = ({
  value,
  active = false,
  onClick,
}) => {
  return (
    <Box
      className={clsx("editable-cell", {
        "editable-cell--active": active,
      })}
      onClick={(e) => onClick(e.currentTarget)}
    >
      <Tooltip
        title={value}
        slotProps={{
          tooltip: {
            className: "edit-cell-tooltip",
          },
        }}
      >
        <Box className="editable-cell__value-wrap">
          <Box
            className={clsx(
              "editable-cell__value",
              value
                ? "editable-cell__value--filled"
                : "editable-cell__value--empty"
            )}
          >
            {value || "-"}
          </Box>
        </Box>
      </Tooltip>

      <EditIcon
        className={clsx("edit-icon", { active })}
      />
    </Box>
  );
};

export default EditableCell;
